/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


/**
 * **Required Permission(s):** ORG_BATCH_PROCESS_LIST
 */
export const listBatchProcessesResponseItem = zod.object({
  "id": zod.string().uuid(),
  "area": zod.enum(['Fsm', 'PayoutRequest']),
  "operation": zod.enum(['Approve', 'Preview', 'Simulate', 'Sync']),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "metadata": zod.object({
  "kind": zod.string()
}).nullish(),
  "createdByUserId": zod.string().uuid().nullish(),
  "createdByName": zod.string().nullish(),
  "createdDate": zod.string().datetime({}),
  "totalCount": zod.number(),
  "pendingCount": zod.number(),
  "inProcessCount": zod.number(),
  "deferredCount": zod.number(),
  "succeededCount": zod.number(),
  "noActionCount": zod.number(),
  "failedCount": zod.number(),
  "isComplete": zod.boolean()
})
export const listBatchProcessesResponse = zod.array(listBatchProcessesResponseItem)

/**
 * **Required Permission(s):** ORG_BATCH_PROCESS_GET
 */
export const getBatchProcessByIdParams = zod.object({
  "id": zod.string().uuid()
})

export const getBatchProcessByIdResponse = zod.object({
  "id": zod.string().uuid(),
  "area": zod.enum(['Fsm', 'PayoutRequest']),
  "operation": zod.enum(['Approve', 'Preview', 'Simulate', 'Sync']),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "metadata": zod.object({
  "kind": zod.string()
}).nullish(),
  "createdByUserId": zod.string().uuid().nullish(),
  "createdByName": zod.string().nullish(),
  "createdDate": zod.string().datetime({}),
  "totalCount": zod.number(),
  "pendingCount": zod.number(),
  "inProcessCount": zod.number(),
  "deferredCount": zod.number(),
  "succeededCount": zod.number(),
  "noActionCount": zod.number(),
  "failedCount": zod.number(),
  "isComplete": zod.boolean()
})

/**
 * **Required Permission(s):** ORG_BATCH_PROCESS_GET
 */
export const listBatchProcessItemsParams = zod.object({
  "id": zod.string().uuid()
})

export const listBatchProcessItemsQueryPageDefault = 1;export const listBatchProcessItemsQueryPageSizeDefault = 25;

export const listBatchProcessItemsQueryParams = zod.object({
  "page": zod.number().default(listBatchProcessItemsQueryPageDefault),
  "pageSize": zod.number().default(listBatchProcessItemsQueryPageSizeDefault),
  "statuses": zod.array(zod.enum(['Pending', 'InProcess', 'Deferred', 'Succeeded', 'NoAction', 'Failed'])).optional()
})

export const listBatchProcessItemsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string().uuid(),
  "referenceType": zod.string(),
  "referenceId": zod.string(),
  "operation": zod.enum(['Approve', 'Preview', 'Simulate', 'Sync']),
  "status": zod.enum(['Pending', 'InProcess', 'Deferred', 'Succeeded', 'NoAction', 'Failed']),
  "startedAt": zod.string().datetime({}).nullish(),
  "endedAt": zod.string().datetime({}).nullish(),
  "outcomeType": zod.string().nullish(),
  "outcomeMessage": zod.string().nullish(),
  "metadata": zod.union([zod.object({
  "kind": zod.string()
}),zod.object({
  "kind": zod.string()
}),zod.object({
  "kind": zod.string()
})]).nullish(),
  "createdDate": zod.string().datetime({})
})),
  "totalCount": zod.number(),
  "page": zod.number(),
  "pageSize": zod.number(),
  "totalPages": zod.number(),
  "hasNextPage": zod.boolean(),
  "hasPreviousPage": zod.boolean()
})

